<template>
  <div>
    <p class="text">{{ $t("yourLifestyle.haveYouEverSmokedMore") }}</p>

    <check-box
      class="check-box"
      v-for="(radioButtonItem, index) in radioButtonItems"
      :key="index"
      :checkedValue="checkedValue"
      :val="radioButtonItem.val"
      @toggle="toggle"
      >{{ radioButtonItem.label }}</check-box
    >
  </div>
</template>

<script>
import CheckBox from "../../atoms/Checkbox";

export default {
  props: {
    checkedValue: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      radioButtonItems: [
        {
          val: 1,
          label: this.$i18n.t("yourLifestyle.neverSmoked")
        },
        {
          val: 2,
          label: this.$i18n.t("yourLifestyle.stopSmoking")
        },
        {
          val: 3,
          label: this.$i18n.t("yourLifestyle.smoking")
        }
      ]
    };
  },
  components: {
    CheckBox
  },
  methods: {
    toggle: function(val) {
      this.$emit("dataInput", val);
    }
  }
};
</script>

<style scoped>
.text {
  text-align: left;
  margin-top: 20px;
}

.check-box {
  text-align: left;
  margin-top: 20px;
}
</style>
